import request from '@/CommonDP/utils/request';
export default {
  // 本部门下的人员列表
  orgUserList(params) {
    return request.post(`/admin/dept/member/list`, params);
  },
  // 部门下的人员列表
  getlistPerson(params) {
    return request.get(`/admin/listPerson`, { params });
  },
  // 左侧树
  getOrgTree(enterpriseId) {
    return request.get(
      `/admin/org/getOrgTree?enterpriseId=${enterpriseId}`
    );
  },

  // 组织详情
  orgInfo(deptId) {
    return request.get(`/admin/org/getDeptDetails?deptId=${deptId}`);
  },
  // 分组下的的字典删除
  delDicContentByID(params) {
    return request
      .post(`/admin/dic/delDicContentByID`, params)
      .then((res) => res);
  }
};
